import { render, staticRenderFns } from "./ObjectView.vue?vue&type=template&id=5d048c8b&"
import script from "./ObjectView.vue?vue&type=script&lang=js&"
export * from "./ObjectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports